import PropTypes from 'prop-types';
import React from 'react';
import './Stage.scss';

const Stage = ({stage, children}) => (
    <div id="stage" className="stage">
        <div className="btn-group btn-breadcrumb">
            {children.map((item, index) => {
                const props = {
                    key: index,
                    width: (100 / children.length) + '%',
                    active: index + 1 === stage,
                };
                return React.cloneElement(item, props);
            })}
        </div>
    </div>
);

Stage.propTypes = {
    stage: PropTypes.number.isRequired,
    children: PropTypes.node,
};

export default Stage;
